import { createAsyncThunk } from '@reduxjs/toolkit';
// Import Axios Admin API (this is where the baseURL is and shared reuqest params are set)
import api from '../../utils/api';
import { setAlert } from '../alerts/actions';

export const get = createAsyncThunk('join-us/get', async (id, { dispatch }) => {
  try {
    const res = await api.get(`/admin/join-us`);
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) =>
        dispatch(setAlert({ message: error.message, alertType: 'error' })),
      );
    }
  }
});

export const edit = createAsyncThunk(
  'join-us/edit',
  async ({ data, navigate }, { dispatch }) => {
    try {
      await api.put(`/admin/join-us`, data);
      dispatch(
        setAlert({
          message: 'Information updated successfully',
          alertType: 'success',
        }),
      );
      navigate(`/cms/join us`);
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);
